/**
 * @generated SignedSource<<264bad9963def1d1553081812e9d4e4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useTeamScheduleLayout_teamScheduleEventOccasion$data = ReadonlyArray<{
  readonly __typename: "RoutineOccasion";
  readonly assigned: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly assignedRoles: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly routine: {
    readonly description: string | null;
    readonly descriptionImages: ReadonlyArray<{
      readonly __typename: "Image";
    }>;
  };
  readonly " $fragmentType": "useTeamScheduleLayout_teamScheduleEventOccasion";
} | {
  readonly __typename: "TeamScheduleInlineRoutineOccasion";
  readonly taskExecution: {
    readonly routineOccasion: {
      readonly __typename: "RoutineOccasion";
      readonly assigned: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly assignedRoles: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly routine: {
        readonly description: string | null;
        readonly descriptionImages: ReadonlyArray<{
          readonly __typename: "Image";
        }>;
      };
    };
  };
  readonly " $fragmentType": "useTeamScheduleLayout_teamScheduleEventOccasion";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "useTeamScheduleLayout_teamScheduleEventOccasion";
}>;
export type useTeamScheduleLayout_teamScheduleEventOccasion$key = ReadonlyArray<{
  readonly " $data"?: useTeamScheduleLayout_teamScheduleEventOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"useTeamScheduleLayout_teamScheduleEventOccasion">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
],
v2 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Routine",
    "kind": "LinkedField",
    "name": "routine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "descriptionImages",
        "plural": true,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "AssignedEmployee",
    "kind": "LinkedField",
    "name": "assigned",
    "plural": true,
    "selections": (v1/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "AssignedRole",
    "kind": "LinkedField",
    "name": "assignedRoles",
    "plural": true,
    "selections": (v1/*: any*/),
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useTeamScheduleLayout_teamScheduleEventOccasion",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskExecutionCheck",
          "kind": "LinkedField",
          "name": "taskExecution",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoutineOccasion",
              "kind": "LinkedField",
              "name": "routineOccasion",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "TeamScheduleInlineRoutineOccasion",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v2/*: any*/),
      "type": "RoutineOccasion",
      "abstractKey": null
    }
  ],
  "type": "TeamScheduleEventOccasion",
  "abstractKey": "__isTeamScheduleEventOccasion"
};
})();

(node as any).hash = "fae18209f5c06ad0c540b3deb943b660";

export default node;
